export const ALL_SUGGESTIONS = [
  'What is time preference and how does it explain the existence of interest?',
  'Why does credit expansion produce malinvestment rather than real growth?',
  'What is the knowledge problem and why did Hayek think central planning cannot solve it?',
  'What is the difference between savings-driven and credit-driven investment?',
  "Why can't a central bank set the right interest rate?",
];

export function getRandomSuggestions() {
  return [...ALL_SUGGESTIONS].sort(() => Math.random() - 0.5).slice(0, 4);
}
